import type { InjectionKey } from 'vue';
import type { FormStore } from '../model/FormStore';

export const FORM_ITEM_INJECTION_KEY = Symbol() as InjectionKey<string>;

export const FORM_INJECTION_KEY = Symbol() as InjectionKey<FormStore>;
